import { gql } from '@apollo/client';

export const PAGINATED_QUESTIONS = gql`
  query Questionsv2($input: QuestionPaginationFilterInput!) {
    questionsv2(input: $input) {
      item {
        ... on QuestionPaginatedResult {
          pageIndex
          pageSize
          totalItems
          totalPages
          hasPreviousPage
          hasNextPage
          data {
            id
            availableLanguages
            shortDescription
            type
            visibility
            text
          }
        }
        ... on QuestionQueryError {
          message
          code
        }
      }
      isSuccess
    }
  }
`;
